fourToldApp.controller("registerCntrl", function ($scope, $sce, $cookieStore, services, docIdTypes, $window, $location, $rootScope, $mdToast, $mdDialog, $route, $routeParams, countryCode, countries, theme, $controller, xmppAuth, $q) {
  var date = new Date();
  var timezone = jstz.determine();
  var deviceId = new ClientJS();
  var logout_response;
  deviceId = deviceId.getCustomFingerprint(deviceId.getCanvasPrint()); // only use canvasPrint to select device Id
  $scope.catpchaVerified = false;
  $scope.showcaptcha = false;
  $scope.showMenuInChangePassword = false;
  $scope.showBackButtonBar = true;
  $scope.dial_codes = countries;
  $scope.docIdTypes = docIdTypes; 
  $scope.register = new Object();
  $scope.register = {
    middleName: "",
    surName: ""
  };
  $scope.onSelect = (it)=>{console.log(it)}
  $scope.foo = $cookieStore.get("acceptedTerms");
  $scope.visible = false;
  $scope.aditional = new Object();
  $scope.theme = theme.getTheme();
  $scope.user_teller_agent = null;
  $scope.user_barcode = null;
  function b64_to_utf8( str ) {
    return decodeURIComponent(escape(window.atob( str )));
  }


  $scope.showLogoHeader = true;
  $scope.emptyRegister = $scope.theme && $scope.theme.emptyRegister == 'yes';
  $scope.isByDocId = $scope.theme && $scope.theme.registerType == 'DOCID';

   document.getElementById("emailRegister").required = true;
   document.getElementById("txtPasswordConfirm").required = true;
   document.getElementById("txtPassword").required = true;

   if($scope.emptyRegister) {
      document.getElementById("emailRegister").required = false;
      document.getElementById("firstName").required = false;
      document.getElementById("middleName").required = false;
      document.getElementById("lastName").required = false;
      document.getElementById("surName").required = false;
      document.getElementById("txtPassword").required = false;
      document.getElementById("txtPasswordConfirm").required = false;
   }


    if($location.search().tag!=null && $location.search().tag!='undefined' && $location.search().user_teller_agent!=null
    && $location.search().user_teller_agent!='undefined' && ($window.navigator.userAgent=== 'commerce-mobile' || ($location.search().mode!=null && $location.search().mode === 'asesorweb')  )){
      $scope.user_teller_agent = $location.search().user_teller_agent;
      $scope.showLogoHeader = false;
      if($location.search().deviceAgentId!=null ){
        deviceId = $location.search().deviceAgentId
      }
      
      document.getElementById("emailRegister").required = false;
      document.getElementById("txtPasswordConfirm").required = false;
      document.getElementById("txtPassword").required = false;
      if($location.search().barcode!=null){
        let barcode = $location.search().barcode;
        try {
          $scope.user_barcode = b64_to_utf8(barcode);       
          $scope.user_barcode = $scope.user_barcode.replaceAll('\u0000',' ');          
      } catch (e) {
          Strophe.error(e);
      }       
      }
      if($location.search().firstName!=null){
        $scope.register.firstName = $location.search().firstName;
      }

      if($location.search().lastName!=null){
        $scope.register.lastName = $location.search().lastName;
      }

      if($location.search().secondLastName!=null){
        $scope.register.surName = $location.search().secondLastName;
      }

      if($location.search().secondName!=null){
        $scope.register.middleName = $location.search().secondName;
      }
    }
  
  if($window.sessionStorage.getItem('requiredPasswordChange')==='true'){
      $scope.showMenuInChangePassword = false;
      $scope.showBackButtonBar = true;
  }
  else{
    $scope.showBackButtonBar = false;
    $scope.showMenuInChangePassword = true;
  }    
  
  if ($scope.theme != null && $scope.theme.captchaRegister != null && $scope.theme.captchaRegister == true) {
    $scope.showcaptcha = true;
  }
  else
    $scope.showcaptcha = false;

  if ($scope.theme && $scope.theme.passwords)
      $scope.hints = $scope.theme.passwords.hints.replace(/(?:\r\n|\r|\n)/g, '<br>');

  if ($scope.theme && $scope.theme.phone && $scope.theme.phone.hints )
    $scope.hints_phone = $scope.theme.phone.hints.replace(/(?:\r\n|\r|\n)/g, '<br>');

    $scope.showAlert = function (message) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('Notificación')
          .textContent(message)
          .ariaLabel('Alert Dialog Demo')
          .ok('Ok')
      );
    };
    function positionUpdate(showLockMessage, isPermissionReqError){
      navigator.geolocation.getCurrentPosition(
        function(position){
          $window.localStorage.setItem("locationPermission", "true");
          $mdDialog.cancel();          
          countryCode.dialCode(true, theme.getTheme())
          .then(function (result) {
            $scope.progressCircular = false;
            $scope.dialCode = result;
          })
          .catch(function (message) {
            $scope.progressCircular = false;
        });                
      },
      function(err){
      switch (err.code) {
      // PERMISSION_DENIED
      case 1:      
      var contentMessage = "Estimado usuario, los permisos de ubicación son necesarios para una mejor experiencia en la solicitud de créditos.";
      $window.localStorage.setItem("locationPermission", "lock");
      if(showLockMessage){
        if($scope.theme!=null && $scope.theme.gps!=null){
          contentMessage = $scope.theme.gps.permissionContent;
          if($window.navigator.userAgent !== 'commerce-mobile'){
            contentMessage = contentMessage + "<br> Para activar los permisos necesarios, puede ver las instrucciones <a href='https://www.youtube.com/watch?v=_JF3Sx8i7qk&amp;ab_channel=4toldfintech' target=\"_blank\">aqu&iacute;</a>"
          }
          if(isPermissionReqError)
            contentMessage = $scope.theme.gps.permissionError;
          if($scope.theme.gps.validation === 'MANDATORY'){
            var confirm = $mdDialog.confirm()
            .title($scope.theme.gps.permissionTitle)
            .htmlContent(contentMessage)
            .ariaLabel('Lucky day')      
            .ok($scope.theme.gps.permissionAccept);
          }
          else{
            var confirm = $mdDialog.confirm()
            .title($scope.theme.gps.permissionTitle)
            .htmlContent(contentMessage)
            .ariaLabel('Lucky day')
            .cancel($scope.theme.gps.permissionReject)
            .ok($scope.theme.gps.permissionAccept);
          }
        }
        else{
          if($window.navigator.userAgent !== 'commerce-mobile'){
            contentMessage = contentMessage + "<br> Para activar los permisos necesarios, puede ver las instrucciones <a href='https://www.youtube.com/watch?v=_JF3Sx8i7qk&amp;ab_channel=4toldfintech' target=\"_blank\">aqu&iacute;</a>"
          }
          var confirm = $mdDialog.confirm()
          .title("Notificación")
          .htmlContent(contentMessage)
          .ariaLabel('Lucky day')      
          .ok("Aceptar");
        }
           $mdDialog.show(confirm).then(function() {      
            
            if(!$window.localStorage.getItem("locationPermission") || $window.localStorage.getItem("locationPermission") =='lock'){
              positionUpdate(showLockMessage, true);
            }
      
          }, function(){
            
          });
      
      }
      else{
      
      }

      countryCode.dialCode(true, theme.getTheme())
      .then(function (result) {
        $scope.progressCircular = false;
        $scope.dialCode = result;
      })
      .catch(function (message) {
        $scope.progressCircular = false;
      
    });  
       
      break
      // POSITION_UNAVAILABLE
      case 2:
      console.log('Permission allowed, location disabled')
      break
      // TIMEOUT
      case 3:
      console.log('Permission allowed, timeout reached')
      break
      }
      
      
      
      }
      );
      }
    function checkGpsMetadata(){
      var showLockMessage = false;      
      if($scope.theme!=null && $scope.theme.gps!=null){
        showLockMessage = true;
        if($scope.theme.gps.validation === 'MANDATORY'){
          if($window.navigator.userAgent !== 'commerce-mobile'){
            contentMessage = $scope.theme.gps.permissionContent + "<br> Para activar los permisos necesarios, puede ver las instrucciones <a href='https://www.youtube.com/watch?v=_JF3Sx8i7qk&amp;ab_channel=4toldfintech' target=\"_blank\">aqu&iacute;</a>"
          }
          var confirm = $mdDialog.confirm()
          .title($scope.theme.gps.permissionTitle)
          .htmlContent(contentMessage)
          .ariaLabel('Lucky day')      
          .ok($scope.theme.gps.permissionAccept);
        }
        else{
          if($window.navigator.userAgent !== 'commerce-mobile'){
            contentMessage = $scope.theme.gps.permissionContent + "<br> Para activar los permisos necesarios, puede ver las instrucciones <a href='https://www.youtube.com/watch?v=_JF3Sx8i7qk&amp;ab_channel=4toldfintech' target=\"_blank\">aqu&iacute;</a>"
          }
          var confirm = $mdDialog.confirm()
          .title($scope.theme.gps.permissionTitle)
          .htmlContent(contentMessage)
          .ariaLabel('Lucky day')
          .cancel($scope.theme.gps.permissionReject)
          .ok($scope.theme.gps.permissionAccept);
        }
          if(!$window.localStorage.getItem("locationPermission")){
            $mdDialog.show(confirm).then(function() {
              if(!$window.localStorage.getItem("locationPermission"))
                checkGpsMetadata();      
            }, function(){
            });
          }
          else{
            if( $window.localStorage.getItem("locationPermission") && $window.localStorage.getItem("locationPermission") == 'lock'){
              showLockMessage = true;
            // positionUpdate(metadataObj,true);
            }
          }
      }
      else{
        if( !$window.localStorage.getItem("locationPermission") ||  $window.localStorage.getItem("locationPermission") == 'lock'){
          if($window.navigator.userAgent !== 'commerce-mobile'){
            contentMessage = "Estimado usuario, los permisos de ubicación son necesarios para una mejor experiencia en la solicitud de créditos. Para activar los permisos necesarios, puede ver las instrucciones <a href='https://www.youtube.com/watch?v=_JF3Sx8i7qk&amp;ab_channel=4toldfintech' target=\"_blank\">aqu&iacute;</a>";
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title("Notificación")
              .htmlContent(contentMessage)
              .ariaLabel('Alert Dialog GPS')
              .ok('Aceptar')
              .targetEvent(null)
          );
          }
        }   
      }
      positionUpdate(showLockMessage, false);
    }
    if (navigator.geolocation) {
      checkGpsMetadata();
    }
  let affiliationCode = "";
  if($window.navigator.userAgent=== 'commerce-mobile'){
    affiliationCode = $location.search().code || null;
  }
  else{
    affiliationCode = $location.search().code || $location.search().tag || null;
  }
  $scope.affiliationCode = $scope.register.affiliationCode = affiliationCode;
  if($location.search().unlockcode!=null && $location.search().unlockcode == 'true')
  {
    $scope.affiliationCode = false;
    $scope.register.affiliationCode = "";
  }
  if ($location.search().land === 'reg') {
    if ($location.search().tlf)
      $scope.phoneNumber = parseInt($location.search().tlf);
    if ($location.search().em)
      $scope.register.email = $location.search().em;
    if ($location.search().nam) {
      var split = $location.search().nam.split(" ");
      $scope.register.firstName = split[0];
      if (split[1])
        $scope.register.middleName = split[1];
    }
    if ($location.search().ap) {
      var split = $location.search().ap.split(" ");
      $scope.register.lastName = split[0];
      if (split[1])
        $scope.register.surName = split[1];
    }
  };
  function validateForm(form) {
    var object = Object.keys(form.$error);    
    $scope.error = true;
    for (var i = 0; i < object.length; i++) {
        switch (object[i]) {
            case "required":
                document.getElementById(form.$error.required[0].$name).focus()
                break;
            case "min":
                document.getElementById(form.$error.min[0].$name).focus()
                break;
            case "max":
                document.getElementById(form.$error.max[0].$name).focus()
                break;
            case "minlength":
                document.getElementById(form.$error.minlength[0].$name).focus()
                break;
            case "maxlength":
                document.getElementById(form.$error.maxlength[0].$name).focus()
                break;
            case "pattern":
                if(document.getElementById(form.$error.pattern[0].$name)){
                  document.getElementById(form.$error.pattern[0].$name).focus()
                  document.getElementById(form.$error.pattern[0].$name).setCustomValidity("Campo inválido");
                }
              break;    
            default:
        }
    };
  };
  $scope.setValidateInput = function(input, form){
    if(form.pattern){
      document.getElementById(input).setCustomValidity("Campo inválido");
    } else {
      document.getElementById(input).setCustomValidity('');
    }
    
  };
  $scope.submitRegister = async function(data, isMatch, invalidEmail, invalidPassword, form)  {
    validateForm(form);
    if(!$scope.catpchaVerified &&($scope.theme!=null && $scope.theme.captchaRegister!=null && $scope.theme.captchaRegister == true)) {      
      $scope.progressCircular = false;
      return;
    }
    if($scope.theme!=null && $scope.theme.phone!=null && $scope.theme.phone.regex!=null && $scope.theme.phone.hints!=null){
      var re = new RegExp($scope.theme.phone.regex);
      if(!re.test($scope.phoneNumber)){
          $scope.dialog($scope.theme.phone.hints, "error-toast");
          return;
      }
    }
    if(($scope.dialCode == null || $scope.dialCode == undefined || $scope.dialCode.length == 0) && !$scope.isByDocId ){
      $scope.showAlert("Debe seleccionar el código de pais");
      $scope.progressCircular = false;
      return;
    }
    
    if($scope.isByDocId && !$scope.docType ){
      $scope.dialog('Debes seleccionar un tipo de documento de identidad', "error-toast");
      return;
    }

    if($scope.theme!=null && $scope.theme.docId!=null && $scope.theme.docId.regex!=null){
      var re = new RegExp($scope.theme.docId.regex);
      if(!re.test($scope.docId)){          
          $scope.dialog($scope.theme.docId.hints || 'Documento inválido', "error-toast");
          return;
      }
    }

    if((!$scope.showLogoHeader || $scope.emptyRegister) && !$scope.isByDocId){
      if($scope.phoneNumber<5)
        $scope.register.password = $scope.phoneNumber;
        else
        $scope.register.password = $scope.phoneNumber.toString().substring($scope.phoneNumber.toString().length-5, $scope.phoneNumber.toString().length)
      $scope.register.email = "no@mail.com";  
      isMatch = true;
      invalidEmail = false;
      invalidPassword = false;
      if($scope.register.lastName!=null )
        data = true;
    }

    if((!$scope.showLogoHeader || $scope.emptyRegister) && $scope.isByDocId){      

      $window.sessionStorage.setItem("loginType",'IDENTIFICATION');
      if($scope.docId < 5)
        $scope.register.password = $scope.docId;
        else
        $scope.register.password = $scope.docId.toString().substring($scope.docId.toString().length-5, $scope.docId.toString().length)
      $scope.register.email = "no@mail.com";  
      isMatch = true;
      invalidEmail = false;
      invalidPassword = false;
      if($scope.register.lastName!=null )
        data = true;
    }


    if($scope.emptyRegister){
      document.getElementById("emailRegister").required = false;
      document.getElementById("firstName").required = false;
      document.getElementById("middleName").required = false;
      document.getElementById("lastName").required = false;
      document.getElementById("surName").required = false;
      document.getElementById("txtPassword").required = false;
      document.getElementById("txtPasswordConfirm").required = false;

      $scope.register.firstName = "";
      $scope.register.middleName = "";
      $scope.register.lastName = "";
      $scope.register.surName = "";
      data = true;
    }
    if(data && isMatch == true && !invalidEmail && !invalidPassword){
      if($window.localStorage.getItem('access_token1')){
        await Async();
      }
      $scope.register.deviceId = deviceId;
      $scope.register.phoneId = deviceId; 
      $scope.register.phonePrefix = $scope.phoneNumber && $scope.dialCode;
      $scope.register.phoneNumber = $scope.phoneNumber && $scope.phoneNumber.toString();
      $window.sessionStorage.setItem("prefix", $scope.register.phonePrefix);
      $scope.register.phoneNumber && $window.sessionStorage.setItem("phoneNumber", $scope.register.phoneNumber);
      $window.sessionStorage.setItem("password", $scope.register.password);
      $window.sessionStorage.setItem("loginType",'PHONENUMBER');

      $scope.register.identification = $scope.docId;      
      $scope.register.identificationType = $scope.docType && $scope.docType.id;

      $scope.register.identificationType && $window.sessionStorage.setItem("identificationType", $scope.register.identificationType);
      $scope.register.identification && $window.sessionStorage.setItem("identification", $scope.register.identification);
      $scope.register.identification && ($scope.register.registrationType = 2)

      var location = {};
      location.label = "REGISTER";
      location.addressLine = "";
      location.longitude = null;
        location.latitude = null;
      if ($rootScope.location !== undefined && $rootScope.latLong !== undefined) {
        var data = $rootScope.location;
        var latLong = $rootScope.latLong;
        location.longitude = latLong.longitude;
        location.latitude = latLong.latitude;
        for (var i = 0; i < data.data.results[0].address_components.length; i++) {
          if (data.data.results[0].address_components[i].types[0] == "administrative_area_level_1")
            location.locality = data.data.results[0].address_components[i].short_name;
          if (data.data.results[0].address_components[i].types[0] == "postal_code")
            location.postalCode = data.data.results[0].address_components[i].short_name;
          if (data.data.results[0].address_components[i].types[0] == "country") {
            location.country = data.data.results[0].address_components[i].short_name;
            $window.sessionStorage.setItem("countryCode", location.country);
          }
        }
        location.addressLine = location.addressLine.trim();
        if (data.data.results[0].formatted_address) {
          location.addressLine = data.data.results[0].formatted_address;
        }
        $scope.register.location = location;
      }
        var selectedLanguage = $window.sessionStorage.getItem("lang");
        var language = null;
        if (selectedLanguage) {
          language = selectedLanguage;
        } else {
          language = navigator.language.split("-");
          if($scope.register.location && $scope.register.location.country)
            language = language[0] + "_" + $scope.register.location.country;
          else
              if(language.length>=2){
                  language = language[0] + '_'+ language[1];
              }
              else
                  language = "";
          }
          $scope.user_teller_agent = $location.search().user_teller_agent || null;
          $scope.register.properties = {
              "language": language,
              "timezone": timezone.name(),
              "timezoneOffset": date.getTimezoneOffset()*60*1000*-1,
              "land": $location.search().land,
              "prf": $location.search().prf,
              "pag": $location.search().pag,
              "am": $location.search().am,
              "des": $location.search().des,
              "pagDesc": $location.search().pagDesc,
              "agentUser":$scope.user_teller_agent,
              "barCode": $scope.user_barcode,
              "productId": $location.search().productId,
              "action": $location.search().action
          };

          services.customUserRegistration($scope).setData({}, $scope.register, function(status) {
            if(status && status.data && status.data.activatedConfigureQuestions === true) {
              $window.sessionStorage.setItem('activatedConfigureQuestions', true);
            } else {
              $window.sessionStorage.setItem('activatedConfigureQuestions', false);
            }
            if(status && status.data && status.data.registerTag)
              $window.sessionStorage.setItem('registerTag', status.data.registerTag);
            switch(status.code) {
                case -1:
                  $scope.progressCircular = undefined;
                  //$scope.showAlert('El número telefónico ' + $scope.register.phoneNumber + ' ya se encuentra registrado');
                  $scope.showAlert('Los datos que ingresaste ya se encuentran registrados');
                  break;
                case 1:
                  $scope.password = $scope.register ? $scope.register : null; 
                  $window.sessionStorage.removeItem("urlTerms");
                  $window.sessionStorage.removeItem("lang");
                  $window.sessionStorage.setItem("userID", status.data.userId);
                  $window.sessionStorage.removeItem("redirectTerms");
              
                  if($location.search().tag!=null && $location.search().tag!='undefined' && $location.search().user_teller_agent!=null
                            && $location.search().user_teller_agent!='undefined' && ($window.navigator.userAgent=== 'commerce-mobile' || ($location.search().mode!=null && $location.search().mode === 'asesorweb') )){
                              $routeParams.verification = true;
                              try {
                                if(Android){
                                  Android.reportNewUser($scope.register.phonePrefix, $scope.register.phoneNumber, $scope.register.password  );                                
                                }           
                              } catch (error) {}
                              $window.sessionStorage.setItem('isAgentWebView', true);
              
                    if(status.data.smsVerificationType!=null && status.data.smsVerificationType === 'MANDATORY'){
                    $location.path("/verification");
                    }
                    else{
                        $controller('loginCntrl', {
                          $scope: $scope
                      });
                      if($scope.isByDocId) {      
                        $scope.submit(true,true, true);
                      } else {
                        $scope.submit(true,true);
                      }
                    }
                    $scope.showLogoHeader = false;
                    
                    document.getElementById("emailRegister").required = false;
                    document.getElementById("txtPasswordConfirm").required = false;
                    document.getElementById("txtPassword").required = false;
                  }
                  else{
                    if(status.data.smsVerificationType!=null && status.data.smsVerificationType === 'MANDATORY'){
                      $routeParams.verification = true;
                      $location.path("/verification");
                      }
                      else{
                          $controller('loginCntrl', {
                            $scope: $scope
                        });
                        if($scope.isByDocId) {    
                          $scope.submit(false, false, true);
                        } else {
                          $scope.submit();
                        }
                      }
                  } 
                  break;
                case -107:
                  $scope.progressCircular = undefined;
                  $scope.showAlert('El correo electrónico ' + $scope.register.email + ' ya se encuentra en uso');
                  break;
                case -204:
                  $scope.progressCircular = undefined;
                  var message = status.message;
                  message = "Código de afiliación inválido";
                  $scope.showAlert(message);
                  break;
                case -5:
                case -105: //Email invalido
                  $scope.progressCircular = undefined;
                  $scope.showAlert("Correo electrónico inválido");
                  break;
                case -111: //Formato de email invalido
                  $scope.progressCircular = undefined;
                  //var message = $scope.renderHtml(status.message);
                  $scope.showAlert("La contraseña debe tener el siguiente formato " + message);
                  break;
                  case -500:
                    $scope.progressCircular = undefined;
                    $scope.showAlert("Error interno en servidor");
                  break;
                  case -219:
                    $scope.progressCircular = undefined;
                    $scope.showAlert("El código de país no es válido");
                  break;
                }
          }, function(error) {
              if(error && error.status === 503 && error.data && error.data.code === -503) {
                  $scope.progressCircular = undefined;                  
                  $scope.showAlert("El sistema no está disponible en estos momentos");
              } else {
                  $scope.progressCircular = undefined;                  
                  $scope.showAlert('Ocurrio un error en el proceso de registro.');
              }
          });
    } else $scope.progressCircular = false;
  };
  function Async(){
      return new Promise((res)=>{
        let token = $window.localStorage.getItem("access_token1");
        $window.localStorage.removeItem("access_token1");
        logout_response = services.logout("bearer " + token).post({}, {}, function (response) {
        });
        $q.all([logout_response.$promise]).then(function(response) {
          xmppAuth.Chat.register = true;
          xmppAuth.Chat.connectionStatus = 0;
          xmppAuth.Chat.disconnect();
          countryCode.dialCode(true, theme.getTheme())
            .then(function () {
              res();
            })
            .catch(function (err) {
              console.log(err);
            });
        });
    });
  }
  $scope.renderHtml = function (htmlCode) {
    return $sce.trustAsHtml(htmlCode);
  };
  $scope.reset = function (form) {
    $scope.register = {};
    $route.reload();
    $scope.aditional = {};
    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  };
  $scope.cancel = function () {
    if ($location.search().tag)
      window.history.back(-2);
    else $location.path('/');
  };
  $scope.dialog = function (message, type) {
    $scope.progressCircular = false;
    $mdToast.show(
      $mdToast.simple()
        .textContent(message)
        .position('top')
        .action('Ok')
        .theme(type)
        .hideDelay(0)
    );
  };
  $scope.showAlertChange = function (message) {
    $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(true)
        .title('Notificación')
        .textContent(message)
        .ariaLabel('Alert Dialog Demo')
        .ok('Ok')
    ).finally(function () {
      $location.path("/dashboard");
      
    });
  };
  $scope.showConfirm = function (message) {
    var confirm = $mdDialog.confirm()
      .title('Notificación')
      .textContent(message)
      .ariaLabel('Lucky day')
      .ok('Ok');
    $mdDialog.show(confirm).then(function () {
      $scope.status = 'You decided to get rid of your debt.';
    });
  };
  $scope.match = function () {
    $scope.isMatch = angular.equals($scope.register.password, $scope.confirm);
  }
  $scope.changePassword = function (ev) {
    if($scope.register.currentPassword && $scope.register.password && $scope.confirm && $scope.isMatch)
        $scope.passwordChange($scope.register.currentPassword, $scope.register.password);    
  }
  $scope.toast = function (messenger, id) {
    toast.options.closeDuration = 500;
    if (id == 0) {
      toastr.error(messenger);
      $scope.error = true;
    } else if (id == 1) {
      toastr.success(messenger);
      $scope.success = true;
    }
  }
  $scope.passwordChange = function (oldPassword, newPassword) {
    $scope.send = "ok";
    $scope.invalid = undefined;
    services.update_password('bearer ' + $window.localStorage.getItem('access_token1')).password({ oldPassword: oldPassword, newPassword: newPassword }, function (response) {
      $scope.send = undefined;
      if (response.code == -24) {
        $scope.invalid = "yes";
        $scope.showAlert('Contraseña inválida.');
      } else if(response.code == 1) 
          $scope.showAlertChange('Contraseña actualizada exitosamente.', 1);
          else{
            $scope.showAlert('Ha ocurrido un error, intente nuevamente mas tarde.');
          }
    }, function (error) {
    });
  }
  $scope.recoverPassword = function () {
    $scope.forgotPassword.phoneNumber = $scope.dialCode + $scope.phoneNumber;
    if ($scope.forgotPassword.phoneNumber) {
      $scope.progressEdit = "ok";
      $scope.forgotPassword.type = $scope.sendType;
      services.recover_password.password({}, $scope.forgotPassword, function (status) {
        $scope.progressEdit = undefined;
        if (status.code !== -2) {
          $mdToast.show(
            $mdToast.simple()
              .textContent('Success')
              .action('Ok')
              .position('top')
              .theme('succes-toast')
              .hideDelay(3000)
          ).then(function () {
            $location.path("/");
          });
        }
      });
    }
  };    
  $scope.passwordChange = function (oldPassword, newPassword) {
    $scope.send = "ok";
    $scope.invalid = undefined;
    services.update_password('bearer ' + $window.localStorage.getItem('access_token1')).password({ oldPassword: oldPassword, newPassword: newPassword }, function (response) {
      $scope.send = undefined;
      if (response.code == -24) {
        $scope.invalid = "yes";
        $scope.showAlert('Contraseña inválida.');
      } else if(response.code == 1) 
          $scope.showAlertChange('Contraseña actualizada exitosamente.', 1);
          else{
            $scope.showAlert('Ha ocurrido un error, intente nuevamente mas tarde.');
          }
    }, function (error) {
    });
  }
  $scope.recoverPassword = function() {
      $scope.forgotPassword.phoneNumber = $scope.dialCode + $scope.phoneNumber;
      if ($scope.forgotPassword.phoneNumber) {           
          $scope.progressEdit = "ok";
          $scope.forgotPassword.type = $scope.sendType;
          services.recover_password.password({}, $scope.forgotPassword, function(status) {
              $scope.progressEdit = undefined;
              if (status.code !== -2) {
                  $mdToast.show(
                      $mdToast.simple()
                      .textContent('Success')
                      .action('Ok')
                      .position('top')
                      .theme('succes-toast')
                      .hideDelay(3000)
                  ).then(function() {
                      $location.path("/");
                  });
              }
          }, function err() {
              $scope.progressEdit = undefined;
              $scope.dialog('Número telefónico incorrecto o Error en el formato telefónico.', 'error-toast');
              $scope.loginError = true;
          });
      }
  }
  if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
    $('#show_hide_password input').attr('type', 'password');
    $('#show_hide_password_confirm input').attr('type', 'password');
    $('#show_hide_current_password input').attr('type', 'password');
  }
  $('#sidebar').css('margin-left', 0);
  $("#show_hide_current_password a").on('click', function(event) {
      event.preventDefault();
      if($('#show_hide_current_password input').attr("type") == "text"){
          switch($('#show_hide_current_password i').hasClass('fa-eye')) {
              case false:
                $('#show_hide_current_password i').removeClass( "fa-eye-slash" );
                $('#show_hide_current_password i').addClass( "fa-eye" );
                break;
              case true:
                $('#show_hide_current_password input').attr('type', 'password');
                $('#show_hide_current_password i').addClass( "fa-eye-slash" );
                $('#show_hide_current_password i').removeClass( "fa-eye" );
                break;
            }
            $('#txtCurrentPassword').css({
              'text-security':'none',
              '-webkit-text-security':'none',
              '-mox-text-security':'none'
            });
      }else if($('#show_hide_current_password input').attr("type") == "password"){
          switch($('#show_hide_current_password i').hasClass('fa-eye-slash')) {
              case false:
                $('#show_hide_current_password i').addClass( "fa-eye-slash" );
                $('#show_hide_current_password i').removeClass( "fa-eye" );
                break;
              case true:
                $('#show_hide_current_password input').attr('type', 'text');
                $('#show_hide_current_password i').removeClass( "fa-eye-slash" );
                $('#show_hide_current_password i').addClass( "fa-eye" );
                break;
            }
      }
  });
  $("#show_hide_password a").on('click', function(event) {
      event.preventDefault();
      if($('#show_hide_password input').attr("type") == "text"){
          switch($('#show_hide_password i').hasClass('fa-eye')) {
              case false:
                $('#show_hide_password i').removeClass( "fa-eye-slash" );
                $('#show_hide_password i').addClass( "fa-eye" );
                break;
              case true:
                $('#show_hide_password input').attr('type', 'password');
                $('#show_hide_password i').addClass( "fa-eye-slash" );
                $('#show_hide_password i').removeClass( "fa-eye" );
                break;
            }
            $('#txtPassword').css({
              'text-security':'none',
              '-webkit-text-security':'none',
              '-mox-text-security':'none'
            });
      }else if($('#show_hide_password input').attr("type") == "password"){
          switch($('#show_hide_password i').hasClass('fa-eye-slash')) {
              case false:
                $('#show_hide_password i').addClass( "fa-eye-slash" );
                $('#show_hide_password i').removeClass( "fa-eye" );
                break;
              case true:
                $('#show_hide_password input').attr('type', 'text');
                $('#show_hide_password i').removeClass( "fa-eye-slash" );
                $('#show_hide_password i').addClass( "fa-eye" );
                break;
            }
      }
  });
  $("#show_hide_password_confirm a").on('click', function(event) {
      event.preventDefault();
      if($('#show_hide_password_confirm input').attr("type") == "text"){
          switch($('#show_hide_password_confirm i').hasClass('fa-eye')) {
              case false:
                $('#show_hide_password_confirm i').removeClass( "fa-eye-slash" );
                $('#show_hide_password_confirm i').addClass( "fa-eye" );
                break;
              case true:
                $('#show_hide_password_confirm input').attr('type', 'password');
                $('#show_hide_password_confirm i').addClass( "fa-eye-slash" );
                $('#show_hide_password_confirm i').removeClass( "fa-eye" );
                break;
            }
            $('#txtPasswordConfirm').css({
              'text-security':'none',
              '-webkit-text-security':'none',
              '-mox-text-security':'none'
            });
      }else if($('#show_hide_password_confirm input').attr("type") == "password"){
          switch($('#show_hide_password_confirm i').hasClass('fa-eye-slash')) {
              case false:
                $('#show_hide_password_confirm i').addClass( "fa-eye-slash" );
                $('#show_hide_password_confirm i').removeClass( "fa-eye" );
                break;
              case true:
                $('#show_hide_password_confirm input').attr('type', 'text');
                $('#show_hide_password_confirm i').removeClass( "fa-eye-slash" );
                $('#show_hide_password_confirm i').addClass( "fa-eye" );
                break;
            }
      }
  });
  $scope.verifyCatpcha = function (response) {
    if (response != null)
      $scope.catpchaVerified = true;
  }
  $scope.captchaErrorCallback = function (response) {
    if ($scope.theme != null && $scope.theme.captchaRegister != null && $scope.theme.captchaRegister == true) {
      console.log("Error cargando captcha");
    }
  }
  $scope.captchaExpiredCallback = function (response) {
    console.log("Captcha expirado");
    $scope.catpchaVerified = false;
  }
  $scope.cancelChancePassword = function(){
    $location.path("/dashboard");
  }

  if($location.search()._token) {
      $scope.isByDocId = true
      $scope.register.password = "123@456"     
      $window.sessionStorage.setItem("loginType",'IDENTIFICATION');       
      $scope.register.email = "no@mail.com";  
      isMatch = true;
      invalidEmail = false;
      invalidPassword = false; 
      data = true; 

    if($scope.emptyRegister) {
      document.getElementById("emailRegister").required = false;
      document.getElementById("firstName").required = false;
      document.getElementById("middleName").required = false;
      document.getElementById("lastName").required = false;
      document.getElementById("surName").required = false;
      document.getElementById("txtPassword").required = false;
      document.getElementById("txtPasswordConfirm").required = false;

      $scope.register.firstName = "";
      $scope.register.middleName = "";
      $scope.register.lastName = "";
      $scope.register.surName = "";
      data = true;
    }
    
      
      $scope.register.deviceId = deviceId;
      $scope.register.phoneId = deviceId; 
      $scope.register.phonePrefix = $scope.phoneNumber && $scope.dialCode;
      $scope.register.phoneNumber = $scope.phoneNumber && $scope.phoneNumber.toString();
      $window.sessionStorage.setItem("prefix", $scope.register.phonePrefix);
      $scope.register.phoneNumber && $window.sessionStorage.setItem("phoneNumber", $scope.register.phoneNumber);
      $window.sessionStorage.setItem("password", $scope.register.password);
      $window.sessionStorage.setItem("loginType",'PHONENUMBER'); 
      var location = {};
      location.label = "REGISTER";
      location.addressLine = "";
      location.longitude = null;
        location.latitude = null;
      if ($rootScope.location !== undefined && $rootScope.latLong !== undefined) {
        var data = $rootScope.location;
        var latLong = $rootScope.latLong;
        location.longitude = latLong.longitude;
        location.latitude = latLong.latitude;
        for (var i = 0; i < data.data.results[0].address_components.length; i++) {
          if (data.data.results[0].address_components[i].types[0] == "administrative_area_level_1")
            location.locality = data.data.results[0].address_components[i].short_name;
          if (data.data.results[0].address_components[i].types[0] == "postal_code")
            location.postalCode = data.data.results[0].address_components[i].short_name;
          if (data.data.results[0].address_components[i].types[0] == "country") {
            location.country = data.data.results[0].address_components[i].short_name;
            $window.sessionStorage.setItem("countryCode", location.country);
          }
        }
        location.addressLine = location.addressLine.trim();
        if (data.data.results[0].formatted_address) {
          location.addressLine = data.data.results[0].formatted_address;
        }
        $scope.register.location = location;
      }
        var selectedLanguage = $window.sessionStorage.getItem("lang");
        var language = null;
        if (selectedLanguage) {
          language = selectedLanguage;
        } else {
          language = navigator.language.split("-");
          if($scope.register.location && $scope.register.location.country)
            language = language[0] + "_" + $scope.register.location.country;
          else
              if(language.length>=2){
                  language = language[0] + '_'+ language[1];
              }
              else
                  language = "";
          }
          $scope.user_teller_agent = $location.search().user_teller_agent || null;
          $scope.register.properties = {
              "language": language,
              "timezone": timezone.name(),
              "timezoneOffset": date.getTimezoneOffset()*60*1000*-1,
              "land": $location.search().land,
              "prf": $location.search().prf,
              "pag": $location.search().pag,
              "am": $location.search().am,
              "des": $location.search().des,
              "pagDesc": $location.search().pagDesc,
              "agentUser":$scope.user_teller_agent,
              "barCode": $scope.user_barcode,
              "productId": $location.search().productId,
          };
          $scope.register.identification = $location.search()._token
          $scope.register.identificationType = "DNI"
          
          $scope.register.password = $scope.register.identification.toString().substring($scope.register.identification.toString().length-5, $scope.register.identification.toString().length)
          $scope.register.token = $location.search()._token
          $scope.register.action = $location.search().action
          
          $window.sessionStorage.setItem("identificationType", $scope.register.identificationType);
          $window.sessionStorage.setItem("identification", $scope.register.identification);
          $scope.register.registrationType = 2

          services.userRegistration.setData({}, $scope.register, function(status) {
            if(status && status.data && status.data.activatedConfigureQuestions === true) {
              $window.sessionStorage.setItem('activatedConfigureQuestions', true);
            } else {
              $window.sessionStorage.setItem('activatedConfigureQuestions', false);
            }
            if(status && status.data && status.data.registerTag)
              $window.sessionStorage.setItem('registerTag', status.data.registerTag);
            switch(status.code) {
                case -1:
                  $scope.progressCircular = undefined;
                  $scope.showAlert('El número telefónico ' + $scope.register.phoneNumber + ' ya se encuentra registrado');
                  break;
                case 1:
                  $scope.password = $scope.register ? $scope.register : null; 
                  $window.sessionStorage.removeItem("urlTerms");
                  $window.sessionStorage.removeItem("lang");
                  $window.sessionStorage.setItem("userID", status.data.userId);
                  $window.sessionStorage.removeItem("redirectTerms");
              
                  $controller('loginCntrl', {
                    $scope: $scope
                  });
                  if($scope.isByDocId) {    
                    $scope.submit(false, false, true);
                  } else {
                    $scope.submit();
                  }

                  break;
                case -107:
                  $scope.progressCircular = undefined;
                  $scope.showAlert('El correo electrónico ' + $scope.register.email + ' ya se encuentra en uso');
                  break;
                case -204:
                  $scope.progressCircular = undefined;
                  var message = status.message;
                  message = "Código de afiliación inválido";
                  $scope.showAlert(message);
                  break;
                case -5:
                case -105: //Email invalido
                  $scope.progressCircular = undefined;
                  $scope.showAlert("Correo electrónico inválido");
                  break;
                case -111: //Formato de email invalido
                  $scope.progressCircular = undefined;
                  //var message = $scope.renderHtml(status.message);
                  $scope.showAlert("La contraseña debe tener el siguiente formato " + message);
                  break;
                  case -500:
                    $scope.progressCircular = undefined;
                    $scope.showAlert("Error interno en servidor");
                  break;
                  case -219:
                    $scope.progressCircular = undefined;
                    $scope.showAlert("El código de país no es válido");
                  break;
                }
          }, function(error) {
              if(error && error.status === 503 && error.data && error.data.code === -503) {
                  $scope.progressCircular = undefined;
                  console.log("error en el proceso del registro");
                  $scope.showAlert("El sistema no está disponible en estos momentos");
              } else {
                  $scope.progressCircular = undefined;
                  console.log("error en el proceso del registro");
                  $scope.showAlert('Ocurrio un error en el proceso de registro.');
              }
          });
    
  }

});
